/* Hero rail ported from prototype/glowme-home.html; real media and collection data rendered by Liquid. */
(function () {
  'use strict';
  var root = document.getElementById('film');
  if (!root) return;

  var links = [].slice.call(root.querySelectorAll('.rail a[data-go]'));
  var rail = document.getElementById('rail'), gnb = document.getElementById('gnb');

  
  var panel = document.getElementById('panel');
  var elCur = document.getElementById('cur'), elTot = document.getElementById('tot');
  var elFill = document.getElementById('fill'), elSay = document.getElementById('say');
  var bPrev = document.getElementById('prev'), bNext = document.getElementById('next');
  var POSTER_MS = parseInt(root.dataset.posterMs, 10) || 8000;    
  
  var FILM_WAIT_MS = 15000;

  function drop(h) {
    links = links.filter(function (a) {
      if (a.dataset.go !== h) return true;
      (a.closest('li') || a).remove(); return false;
    });
  }
  var films = [].slice.call(root.querySelectorAll('.slide')).filter(function (s) {
    var ok = !!s.querySelector('picture img') || !!(s.dataset.filmD || '').trim();
    if (!ok) { drop(s.dataset.handle); s.remove(); }
    return ok;
  });

  var total = films.length;
  if (total === 0) { root.remove(); if (gnb) gnb.classList.add('is-solid'); return; }
  var single = total === 1;
  if (single) { if (bPrev) bPrev.hidden = true; if (bNext) bNext.hidden = true; }

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var blocked = reduce || !!(conn && conn.saveData);
  var mobile = matchMedia('(max-width: 1023px)');

  var i = 0, timer = null, t0 = 0, railBusy = 0, prevIdx = 0, loopSnap = null, covered = false;
  var posterRun = false;   
  var pendingIndex = null, preparation = null, navigation = 0, fadeTimer = null, initialized = false;
  var FADE_MS = reduce ? 0 : 600;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var vid = function (n) { return films[n].querySelector('video'); };

  function src(s) { var d = s.dataset.filmD || '', m = s.dataset.filmM || ''; return (mobile.matches && m) ? m : d; }
  function attach(n) {
    var v = vid(n); if (!v || v.dataset.on === '1') return;
    var u = src(films[n]); if (!u) return;
    v.dataset.on = '1'; v.muted = true; v.playsInline = true; v.crossOrigin = 'anonymous'; v.preload = 'auto'; v.src = u; v.load();
  }

  function playbackRange(n) {
    var v=vid(n), duration=v && isFinite(v.duration) ? v.duration : 0;
    var start=Math.max(0,parseFloat(films[n].dataset.trimStart)||0), trim=Math.max(0,parseFloat(films[n].dataset.trimEnd)||0);
    if (!duration || start+trim>=duration-.25) return {start:0,end:duration};
    return {start:start,end:duration-trim};
  }

  // Keep the current slide visible until a decoded frame at the intended
  // in-point is available. A `playing` event alone is too early.
  function prepareVideo(n, signal) {
    var v=vid(n); if (!v || !src(films[n]) || v.error || blocked || covered) return Promise.resolve(false);
    return new Promise(function(resolve) {
      var done=false, frameId=null, fallbackId=null, started=false, startedAt=0, limit=setTimeout(function(){finish(false,'timeout');},5000);
      v.dataset.prepareState='metadata';
      function finish(ok, reason) {
        if (done) return; done=true;clearTimeout(limit);
        v.removeEventListener('loadedmetadata',ready);
        v.removeEventListener('error',failed);signal.removeEventListener('abort',failed);
        if (frameId!==null)v.cancelVideoFrameCallback(frameId);
        if (fallbackId!==null)cancelAnimationFrame(fallbackId);
        v.dataset.prepareState=ok?'ready':reason||'aborted';
        if (!ok) v.pause(); resolve(ok);
      }
      function failed(){finish(false,signal.aborted?'aborted':'error');}
      function decoded(){return !v.seeking && v.readyState>=2 && v.videoWidth>0 && v.currentTime>=playbackRange(n).start-.02;}
      function frame() {
        frameId=null;
        if (signal.aborted) {finish(false);return;}
        if(decoded()){v.dataset.frameReady='1';finish(true);}
        else frameId=v.requestVideoFrameCallback(frame);
      }
      function fallback(now) {
        fallbackId=null;if(done)return;
        // Some browsers withhold compositor callbacks for visibility:hidden
        // layers. Decoded post-seek data remains a valid bounded fallback.
        if(now-startedAt>=120 && decoded()){v.dataset.frameReady='1';finish(true);return;}
        fallbackId=requestAnimationFrame(fallback);
      }
      function ready() {
        if (done || started || signal.aborted || v.readyState<1) return;
        var start=playbackRange(n).start;
        started=true;startedAt=performance.now();v.dataset.prepareState='frame';
        if (Math.abs(v.currentTime-start)>.02)v.currentTime=start;
        if(typeof v.requestVideoFrameCallback==='function')frameId=v.requestVideoFrameCallback(frame);
        fallbackId=requestAnimationFrame(fallback);
        var result=v.play();
        if (result && result.catch) result.catch(function(error){if(error.name==='NotAllowedError')blocked=true;finish(false);});
      }
      v.addEventListener('loadedmetadata',ready);
      v.addEventListener('error',failed);signal.addEventListener('abort',failed);
      if (signal.aborted) finish(false);else ready();
    });
  }

  function retireSlides(keep) {
    films.forEach(function(s,n){
      if(n===i || n===keep || n===pendingIndex)return;
      s.classList.remove('is-leaving');
      var v=vid(n);if(v){v.pause();v.classList.remove('is-playing');delete v.dataset.frameReady;}
    });
  }

  function phase(name) {
    root.dataset.heroPhase=name;
    root.dispatchEvent(new CustomEvent('gm:hero-change',{detail:{phase:name}}));
  }

  function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } t0 = 0; posterRun = false; }
  
  function arm(showPoster) {
    clearTimer();
    if (blocked || covered || single) return;
    t0 = Date.now();
    posterRun = !!showPoster || !src(films[i]);
    timer = setTimeout(function () { go(i + 1); }, posterRun ? POSTER_MS : FILM_WAIT_MS);
  }
  function fileError(n) { if (n !== i) return; var v = vid(n); if (v) v.classList.remove('is-playing'); arm(true); }
  function envBlocked() { blocked = true; clearTimer(); }

  
  var COPIES = 3, MID = 1, copy = MID, itemW = 0, looped = false;
  function buildLoop() {
    if (!rail || single) return;
    var originals = [].slice.call(rail.children);
    function copyOf() {
      var frag = document.createDocumentFragment();
      originals.forEach(function (li) {
        var c = li.cloneNode(true); c.dataset.clone = '1';
        var a = c.querySelector('a');
        if (a) { a.setAttribute('aria-hidden','true'); a.setAttribute('tabindex','-1'); a.removeAttribute('aria-current'); }
        frag.appendChild(c);
      });
      return frag;
    }
    rail.insertBefore(copyOf(), rail.firstChild);
    rail.appendChild(copyOf());
    rail.classList.add('is-looped');
    looped = true;
  }
  var slotOverride = 0;
  function measure() {
    if (!rail || !links[0]) return;
    
    if (matchMedia('(min-width: 1024px)').matches) {
      rail.style.setProperty('--rail-item', (rail.clientWidth / (slotOverride || Math.min(total, 5))) + 'px');
    } else {
      rail.style.removeProperty('--rail-item');
    }
    var li = links[0].closest('li') || links[0];
    itemW = li.offsetWidth || 0;
  }
  function railTarget(n, c) {
    if (!looped) {
      var l0 = links[n].closest('li') || links[n];
      return Math.max(0, Math.min(l0.offsetLeft - (rail.clientWidth - l0.offsetWidth) / 2, rail.scrollWidth - rail.clientWidth));
    }
    return Math.round((c * total + n) * itemW - (rail.clientWidth - itemW) / 2);
  }
  function settleLoop(n, c) {
    if (!looped || c === MID) { copy = c; return; }
    rail.scrollLeft = railTarget(n, MID); copy = MID;
  }
  function centre(n, smooth) {
    if (!rail || !links[n]) return;
    if (looped && !itemW) measure();
    var c = copy;
    if (looped) {
      if (n === 0 && prevIdx === total - 1) c = copy + 1;
      else if (n === total - 1 && prevIdx === 0) c = copy - 1;
      c = Math.max(0, Math.min(c, COPIES - 1));
    }
    var to = railTarget(n, c);
    railBusy = Date.now();
    if (smooth && !reduce && rail.scrollTo) {
      rail.scrollTo({ left: to, behavior: 'smooth' });
      clearTimeout(loopSnap);
      loopSnap = setTimeout(function () { settleLoop(n, c); railBusy = Date.now(); }, 420);
    } else { rail.scrollLeft = to; settleLoop(n, c); }
  }
  function markClones() {
    if (!rail || !looped) return;
    var h = films[i].dataset.handle;
    [].slice.call(rail.querySelectorAll('a')).forEach(function (a) {
      if (!a.hasAttribute('aria-hidden')) return;
      if (a.dataset.go === h) a.setAttribute('data-on','');
      else a.removeAttribute('data-on');
    });
  }

  async function go(n, fromRail) {
    if (single) n = 0;
    else if (n < 0) n = total - 1;
    else if (n >= total) n = 0;
    clearTimer();
    if (preparation) preparation.abort();
    var turn=++navigation;preparation=new AbortController();pendingIndex=n;
    var pv=vid(i);if(pv)pv.pause();
    phase('loading');attach(n);
    var ready=await prepareVideo(n,preparation.signal);
    if(turn!==navigation || preparation.signal.aborted)return;
    preparation=null;pendingIndex=null;
    clearTimeout(fadeTimer);retireSlides(n);
    var previous=films[i], first=!initialized;
    if(!first && n!==i)previous.classList.add('is-leaving');
    previous.classList.remove('is-on');
    if (links[i]) links[i].removeAttribute('aria-current');

    prevIdx = i; i = n;
    var s = films[i];
    if(vid(i))vid(i).classList.toggle('is-playing',ready);
    s.classList.add('is-on');
    if (links[i]) links[i].setAttribute('aria-current','true');
    markClones();

    
    initialized=true;phase(first?'idle':'crossfade');
    fadeTimer=setTimeout(function(){retireSlides();if(pendingIndex===null)phase('idle');},first?0:FADE_MS);

    if (elCur) elCur.textContent = pad(i + 1);
    if (elSay) elSay.textContent = 'Film ' + (i + 1) + ' sur ' + total + ' — ' + s.dataset.name;
    setFill(0);
    if (!fromRail) centre(i, true);

    if (!single) attach((i + 1) % total);
    resetFill();
    if(ready){clearTimer();play();}else arm(true);
  }

  function play() {
    if (covered) return;
    var v = vid(i); if (!v) return;
    if (blocked) { v.classList.remove('is-playing'); return; }
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      if (err && err.name === 'NotAllowedError') envBlocked(); else fileError(i);
    });
  }
  
  var segMax = 0;                      
  function resetFill() { segMax = 0; setFill(0); }
  function setFill(p) {
    if (!elFill) return;
    p = Math.min(Math.max(p, 0), 1);
    if (p < segMax) p = segMax; else segMax = p;
    elFill.style.width = (((i + p) / total) * 100).toFixed(2) + '%';
  }
  function tick() {
    requestAnimationFrame(tick);
    var v = vid(i);
    var hasFilm = !!src(films[i]);
    if (posterRun) { setFill((Date.now() - t0) / POSTER_MS); return; }
    if (v && isFinite(v.duration) && v.duration > 0 && v.currentTime > 0) {
      var range=playbackRange(i);
      setFill((v.currentTime-range.start)/(range.end-range.start));
      if (!covered && pendingIndex===null && range.end<v.duration && v.currentTime>=range.end) go(i+1);
      return;
    }
    
    if (hasFilm) setFill(0);
  }

  films.forEach(function (s, n) {
    var v = s.querySelector('video'); if (!v) return;
    v.addEventListener('playing', function () { if (n !== i || pendingIndex!==null || !v.dataset.frameReady) return; v.classList.add('is-playing'); clearTimer(); });
    v.addEventListener('ended', function () { if (n !== i || blocked || covered || pendingIndex!==null) return; go(i + 1); });
    v.addEventListener('error', function () { fileError(n); });
  });

  if (bPrev) bPrev.addEventListener('click', function () { go((pendingIndex===null?i:pendingIndex) - 1); });
  if (bNext) bNext.addEventListener('click', function () { go((pendingIndex===null?i:pendingIndex) + 1); });

  
  links.forEach(function (a, n) {
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      if (n === i) return;
      e.preventDefault(); go(n);
    });
  });
  if (rail) rail.addEventListener('click', function (e) {
    var a = e.target.closest('a[aria-hidden]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var h = a.getAttribute('href'), n = -1;
    links.forEach(function (x, k) { if (x.getAttribute('href') === h) n = k; });
    if (n < 0 || n === i) return;
    e.preventDefault(); go(n);
  });

  
  function isCurrent(a) {
    return a.hasAttribute('aria-current') || a.hasAttribute('data-on');
  }
  if (rail) {
    rail.addEventListener('mouseover', function (e) {
      var a = e.target.closest('.rail a');
      if (a && isCurrent(a)) a.setAttribute('data-linkable', '');
    });
    rail.addEventListener('mouseout', function (e) {
      var a = e.target.closest('.rail a');
      if (!a) return;
      
      if (e.relatedTarget && a.contains(e.relatedTarget)) return;
      a.removeAttribute('data-linkable');
    });
  }

  if (rail) {
    var settle = null;
    rail.addEventListener('scroll', function () {
      if (Date.now() - railBusy < 700) return;
      clearTimeout(settle);
      settle = setTimeout(function () {
        var best;
        if (looped && itemW) {
          var slot = Math.round((rail.scrollLeft + (rail.clientWidth - itemW) / 2) / itemW);
          best = ((slot % total) + total) % total;
          copy = Math.max(0, Math.min(Math.floor(slot / total), COPIES - 1));
        } else {
          var mid = rail.scrollLeft + rail.clientWidth / 2, d = Infinity; best = 0;
          links.forEach(function (a, n) {
            var li = a.closest('li') || a, c = li.offsetLeft + li.offsetWidth / 2;
            if (Math.abs(c - mid) < d) { d = Math.abs(c - mid); best = n; }
          });
        }
        if (best !== i) go(best, true);
      }, 140);
    }, { passive: true });
  }

  root.addEventListener('keydown', function (e) {
    if (single) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
  });

  
  function coverage() {
    var was = covered;
    covered = document.hidden || (!!panel && panel.getBoundingClientRect().top <= 4) || !!document.querySelector('.dr.is-on');
    if (covered === was) return;
    var v = vid(i);
    if (covered) { if (v) v.pause(); if(preparation)preparation.abort(); clearTimer(); }
    else if(pendingIndex!==null) go(pendingIndex);
    else { arm(); play(); }
  }
  addEventListener('scroll', coverage, { passive: true });
  document.addEventListener('visibilitychange', coverage);
  document.addEventListener('gm:drawer', coverage);
  coverage();

  if (mobile.addEventListener) mobile.addEventListener('change', function () {
    films.forEach(function (s) { var v = s.querySelector('video'); if (v) { v.pause();v.classList.remove('is-playing');delete v.dataset.frameReady;v.dataset.on='0'; v.removeAttribute('src'); } });
    go(i); measure(); centre(i, false);
  });
  addEventListener('resize', function () { measure(); centre(i, false); });

  if (elTot) elTot.textContent = pad(total);

  buildLoop(); measure(); go(0); centre(0, false); markClones(); tick();
})();

/* Shared prototype drawer/navigation behavior, backed by native Shopify endpoints. */
(() => {
  'use strict';
  let current = null, opener = null;
  const scrim = document.getElementById('scrim');
  const focusable = box => [...box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex="0"]')].filter(e=>e.getClientRects().length);
  function close(quiet=false) {
    if(!current)return;
    const box=current, button=opener; current=null;opener=null;
    box.classList.remove('is-on'); box.hidden=true;
    if(scrim){scrim.classList.remove('is-on');scrim.hidden=true;}
    document.documentElement.style.overflow='';button?.setAttribute('aria-expanded','false');
    document.dispatchEvent(new Event('gm:drawer'));
    if(!quiet)button?.focus({preventScroll:true});
  }
  function open(id,button) {
    const box=document.getElementById(id);if(!box)return false;
    if(current===box)return true;
    if(current)close(true);current=box;opener=button||document.activeElement;
    box.hidden=false;if(scrim)scrim.hidden=false;
    document.documentElement.style.overflow='hidden';opener?.setAttribute?.('aria-expanded','true');
    requestAnimationFrame(()=>requestAnimationFrame(()=>{if(current===box){box.classList.add('is-on');scrim?.classList.add('is-on');document.dispatchEvent(new Event('gm:drawer'));}}));
    (box.querySelector('input[type=search]')||focusable(box)[0])?.focus({preventScroll:true});return true;
  }
  window.GlowmeDrawer={open,close};
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-open]');
    if(trigger&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&event.button===0){if(open(trigger.dataset.open,trigger))event.preventDefault();return;}
    if(event.target.closest('[data-close]')||event.target===scrim){event.preventDefault();close();}
    const accordion=event.target.closest('[data-mobile-acc]');
    if(accordion){
      event.preventDefault();
      const panel=document.getElementById(accordion.getAttribute('aria-controls'));
      const expanded=accordion.getAttribute('aria-expanded')==='true';
      accordion.setAttribute('aria-expanded',String(!expanded));
      accordion.closest('.acc')?.classList.toggle('is-open',!expanded);
      if(panel) panel.style.height=expanded?'0px':`${panel.scrollHeight}px`;
      return;
    }
    const nav=event.target.closest('.nav__top[aria-controls]');
    if(nav){const item=nav.closest('.nav__item'),expanded=!item.classList.contains('is-open');item.classList.toggle('is-open',expanded);item.classList.toggle('is-shut',!expanded);nav.setAttribute('aria-expanded',String(expanded));}
  });
  document.addEventListener('keydown',event=>{
    if(current){
      if(event.key==='Escape'){event.preventDefault();close();return;}
      if(event.key==='Tab'){const items=focusable(current),first=items[0],last=items.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}}
    }else if(event.key==='Escape')document.querySelectorAll('.nav__item').forEach(item=>{item.classList.remove('is-open');item.classList.add('is-shut');item.querySelector('button')?.setAttribute('aria-expanded','false');});
  });
  document.querySelectorAll('.nav__item').forEach(item=>{item.addEventListener('mouseleave',()=>item.classList.remove('is-open','is-shut'));item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))item.classList.remove('is-open','is-shut');});});
  const nav=document.querySelector('.gnb__nav');
  if(nav){
    const items=[...nav.querySelectorAll('.nav__item')];
    const placePanels=()=>{
      const header=document.getElementById('gnb');
      const y=Math.round(header?.getBoundingClientRect().bottom||0);
      const navLeft=Math.round(nav.getBoundingClientRect().left);
      items.forEach(item=>{
        const panel=item.querySelector('.nav__panel');
        if(!panel)return;
        panel.style.top=`${y}px`;
        const inner=panel.querySelector('.nav__inner');
        if(inner&&!panel.hasAttribute('data-wide')){
          const base=Math.round(inner.getBoundingClientRect().left);
          inner.style.paddingLeft=navLeft>base?`${navLeft-base}px`:'';
        }
      });
    };
    placePanels();
    addEventListener('resize',placePanels);
    items.forEach(item=>item.addEventListener('mouseenter',placePanels));
  }
  // Keep the clicked category highlighted on taxonomy-filtered collection pages.
  const activeCategory = new URLSearchParams(location.search).get('gm_category');
  document.querySelectorAll('[data-all-products-link]').forEach(link => {
    const isAllProducts = location.pathname.replace(/\/$/, '') === new URL(link.href, location.origin).pathname.replace(/\/$/, '') && !activeCategory;
    if (isAllProducts) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
  if (activeCategory) {
    const activeLink = document.querySelector('.gnb__nav .nav__top[data-category="' + activeCategory + '"]');
    activeLink?.setAttribute('aria-current', 'page');
  }
  function headerSurface(){
    const header=document.getElementById('gnb'),panel=document.getElementById('panel'),film=document.getElementById('film');
    if(!header)return;
    // Initial layout can be measured before the film's stylesheet has settled.
    // A homepage at scroll zero must never retain that premature solid state.
    const solid=!film||(window.scrollY>1&&panel&&panel.getBoundingClientRect().top<=header.getBoundingClientRect().bottom);
    header.classList.toggle('is-solid',!!solid);
  }
  addEventListener('scroll',headerSurface,{passive:true});
  addEventListener('resize',headerSurface);
  addEventListener('load',headerSurface);
  addEventListener('pageshow',headerSurface);
  if(window.ResizeObserver){
    const surfaceObserver=new ResizeObserver(headerSurface);
    ['film','panel','gnb'].forEach(id=>{const element=document.getElementById(id);if(element)surfaceObserver.observe(element);});
  }
  headerSurface();
  document.addEventListener('change',event=>{if(event.target.matches('[data-auto-submit]'))event.target.form.requestSubmit();});
  let searchTimer, searchRequest;
  document.addEventListener('input',event=>{
    const input=event.target.closest('[data-predictive-search]');if(!input)return;
    clearTimeout(searchTimer);searchRequest?.abort();
    const results=document.querySelector('[data-search-results]'),empty=document.querySelector('[data-search-empty]'),query=input.value.trim();
    if(!query){results.replaceChildren();empty.hidden=false;input.setAttribute('aria-expanded','false');return;}
    searchTimer=setTimeout(async()=>{
      const request=new AbortController();searchRequest=request;
      const url=new URL(input.dataset.url,location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('section_id','gm-predictive-search');
      try{const response=await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('Search unavailable');const html=new DOMParser().parseFromString(await response.text(),'text/html'),section=html.querySelector('#shopify-section-gm-predictive-search');if(!section)return;results.replaceChildren(...section.childNodes);empty.hidden=true;input.setAttribute('aria-expanded','true');}
      catch(error){if(error.name==='AbortError')return;results.replaceChildren();empty.hidden=false;input.setAttribute('aria-expanded','false');}
    },200);
  });
})();
